import React, { useState } from "react";
import { Modal, Button, Input, Rate } from "antd";
import AcceptedIcon from "../../assets/images/order-status-image/success-icon.svg";
import PackingIcon from "../../assets/images/order-status-image/order-packing-icon.svg";
import ReadyIcon from "../../assets/images/order-status-image/order-ready-icon.svg";
import OnWayIcon from "../../assets/images/order-status-image/order-on-the-way.svg";
import DeliveredIcon from "../../assets/images/order-status-image/order-delivered.svg";
import PendingIcon from "../../assets/images/order-status-image/order-pending.svg";
import CancelIcon from "../../assets/images/order-status-image/cancel-order.svg";
import { ShoppingCart, Star } from "lucide-react";
import LeaveFeedbackModal from "./LeaveFeedbackModal";
import ThanksModal from "./ThanksModal";
import moment from "moment";
import { useStore } from "../../context/StoreContext";
import { Severty, ShowToast } from "../../helper/toast";

const TrackOrderModal = ({ open, onClose, step, order }) => {
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const [thanksOpen, setThanksOpen] = useState(false);
  const { reOrder } = useStore();

  const handleFeedbackSubmit = () => {
    setFeedbackOpen(false);
    setTimeout(() => setThanksOpen(true), 300);
  };

  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");

  const handleSubmit = () => {
    onClose();
    setRating(0);
    setFeedback("");
  };

  const handleReOrder = async (orderId) => {
    const response = await reOrder(orderId);
    if (response.status === 200 || response.status === 201) {
      onClose();
      ShowToast(
        response.message || "Order reordered successfully",
        Severty.SUCCESS
      );
    }
  };

  // ---------- setp data according to show title and image in modal --------
  const stepsData = [
    {
      status: "Pending",
      title: "Pending",
      img: PendingIcon,
      activeSteps: 1,
    },
    {
      status: "Accepted",
      title: "Accepted",
      img: AcceptedIcon,
      activeSteps: 2,
    },
    {
      status: "Packing",
      title: "Packing",
      img: PackingIcon,
      activeSteps: 3,
    },
    {
      status: "ReadyToShip",
      title: "Ready to deliver",
      img: ReadyIcon,
      activeSteps: 4,
    },
    {
      status: "Ontheway",
      title: "On the way",
      img: OnWayIcon,
      activeSteps: 5,
    },
    {
      status: "Delivered",
      title: "Delivered",
      img: DeliveredIcon,
      activeSteps: 6,
    },
    {
      status: "Cancel",
      title: "Cancel",
      img: CancelIcon,
      activeSteps: 0,
    },
  ];
  const currentStep =
    stepsData.find((step) => step.status === order?.status) || stepsData[0];

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={600}
      centered
      className="track-order-modal"
    >
      <div className="track-modal-header">
        <h6>Order Status</h6>
        <div className="order-name-id">
          <h2>
            Order <span>{order?.orderId}</span>{" "}
            <span className="order-date">
              {moment(order?.eta).format("MMM Do YY")}
            </span>
          </h2>
        </div>
      </div>

      <div className="order-status-image">
        <img src={currentStep.img} alt="order-icon" />
      </div>

      <div className="step-content">
        <h3>{order?.status}</h3>
        <p>Delivery in about {moment(order?.eta).format("MMM Do YY")}</p>

        <div className="order-status-progress">
          {[...Array(6)].map((_, index) => (
            <span
              key={index}
              className={index < currentStep.activeSteps ? "active" : ""}
            ></span>
          ))}
        </div>
      </div>

      {currentStep.title === "Delivered" && (
        <div className="order-modal-section">
          <Button
            className="fill-button-smal "
            onClick={() => handleReOrder(order?.id)}
          >
            <ShoppingCart /> Reorder
          </Button>
          <Button className="social-btn" onClick={() => setFeedbackOpen(true)}>
            <Star />
            Leave feedback
          </Button>
          <LeaveFeedbackModal
            open={feedbackOpen}
            onClose={() => setFeedbackOpen(false)}
            onSubmit={handleFeedbackSubmit}
          />

          <ThanksModal open={thanksOpen} onClose={() => setThanksOpen(false)} />
        </div>
      )}
    </Modal>
  );
};

export default TrackOrderModal;
